import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { MassOverwriteDialog } from './MassOverwriteDialog';

export const MassOverwriteButton = ({
  toolTip,
  kpiCodes,
  entity,
  role: roleProp,
  defaultDimValues
}) => {

  const { openDialog } = useDialog();

  // Only render if the use has appropriate Role
  const module = useModuleFromRoute();
  const { hasRole } = usePrincipal();
  
  const role = roleProp ?? module.toUpperCase() + '_' + entity + '_SAVE';
  if (!hasRole(`${role}`)) return;

  const handleOpen = () => {
    openDialog(MassOverwriteDialog, {
      kpiCodes,
      entity,
      defaultDimValues
    });
  }

  return (
    <>
      <TitleButton
        icon={fas.faSlidersH}
        toolTip={toolTip}
        onClick={handleOpen}
      />
    </>
  );
}